export default __webpack_public_path__ + "static/bg.jpg";